namespace Areas.Dialogs.CreateBudgetAccountCategory {
    "use strict";

    let accountId: number;
    let parentId: number;
    let groupLk: string;

    let baseURL = "/Budget/Profile/PostBudgetAccountCategory";

    export function getAccountID() {
        return accountId;
    }


    export class CreateBudgetAccountCategoryDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any) {
            super("CreateBudgetAccountCategory",
                closeHandler,
                parameters,
                () => {

                    const form = $("#CreateBudgetAccountCategoryForm").dxForm("instance");
                    const formData: any = form.option("formData");
                    accountId = !parameters.data ? parameters.accountId : parameters.data.accountId;
                    groupLk = !parameters.data ? parameters.budgetCategoryGroupLk : parameters.data.budgetCategoryGroupLk;
                    formData.AccountId = accountId;
                    formData.BudgetCategoryGroupLk = groupLk;    //UCOPSubCode P0,P1-P9
                    form.option("formData", formData);
                });
        }

        protected ok = (e: any) => {
            const form = $("#CreateBudgetAccountCategoryForm").dxForm("instance");
            const result: any = form.validate();
            const formData: any = form.option("formData");
            let keyId = formData.BudgetAccountCategoryId;

            if (result.isValid) {

                const newData: any = form.option("formData");

                sendRequest(`${baseURL}/${keyId}`,
                    JSON.stringify(newData),
                    "POST",
                    () => {
                        this.close(DialogResult.Ok, null);
                    });


            }
        }

    }


}
